import React, { Component } from "react";

interface Item {
	value: string;
	label: string;
}

type OnChange = (value: string) => void;

const Select = ({
	prompt = null,
	name = null,
	className = null,
	value,
	items,
	onChange,
	disabled = false,
}: {
	prompt?: string;
	name?: string;
	className?: string;
	value: null | string;
	items: Item[];
	onChange: OnChange;
	disabled?: boolean;
}) => {
	let options = [];

	if (prompt) {
		options.push(
			<option value="" key="prompt">
				{prompt}
			</option>
		);
	}

	items.forEach((item) => {
		options.push(
			<option value={item.value.toString()} key={item.value}>
				{item.label}
			</option>
		);
	});

	return (
		<select
			{...{ name, className }}
			value={value || ""}
			onChange={(e) => {
				onChange(e.target.value);
			}}
			disabled={disabled}
		>
			{options}
		</select>
	);
};

export default Select;
